import RodoWFFMDataExchange from '@/services/RodoWFFMDataExchange'

/**
 * A mixin adding rodo editing logic and data
 */
export default {

  data () {
    const storedData = this.loadFromStorage() || {}
    const storedChecklist = (storedData && storedData.rodoFormAgreements && storedData.rodoFormAgreements.checklist) || []

    // Initialize dx before using it
    const dx = { rodo: new RodoWFFMDataExchange(this.form) }
    const initialChecklist = dx.rodo.checklist || []

    const mergedChecklist = initialChecklist.map(item => {
      const storedItem = storedChecklist.find(stored => stored.id === item.id)
      return {
        ...item,
        selected: storedItem ? storedItem.selected : false,
      }
    })

    return {
      dx,
      rodo: {
        checklist: mergedChecklist,
        user: [],
      },
      dataReady: false,
    }
  },
  mounted () {
    if (this.dx && this.dx.rodo) {
      this.rodo.user = this.dx.rodo.user
    }
  },
  methods: {
    setRodoUser () {
      this.dx.rodo.user = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email,
        phoneNumber: this.user.phone,
      }
    },
    setRodoAgreements () {
      this.dx.rodo.checklist = this.rodo.checklist
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/booking/logic/RodoForm.js